export type ChangelogGroup = {
  title: string
  items: string[]
}

export type ChangelogRelease = {
  version: string
  date: string | null
  intro: string[]
  groups: ChangelogGroup[]
}

const unreleasedHeading = "não publicado"

const groupLabels: Record<string, string> = {
  adicionado: "Novidades",
  alterado: "Melhorias",
  corrigido: "Correções",
  removido: "Removido",
}

// Plain-text rendering of the inline Markdown used in CHANGELOG.md.
function plainText(line: string) {
  return line
    .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    .trim()
}

export function parseChangelog(source: string): ChangelogRelease[] {
  const releases: ChangelogRelease[] = []
  let release: ChangelogRelease | null = null
  let group: ChangelogGroup | null = null

  for (const rawLine of source.split(/\r?\n/)) {
    const line = rawLine.trim()

    const releaseMatch = /^##\s+(.+?)(?:\s+[—–-]\s+(\d{4}-\d{2}-\d{2}))?$/.exec(line)
    if (releaseMatch) {
      const version = releaseMatch[1].replace(/^\[|\]$/g, "").trim()
      group = null
      if (version.toLowerCase() === unreleasedHeading) {
        release = null
        continue
      }
      release = { version, date: releaseMatch[2] ?? null, intro: [], groups: [] }
      releases.push(release)
      continue
    }

    if (!release) continue

    if (line.startsWith("### ")) {
      const heading = line.slice(4).trim()
      group = { title: groupLabels[heading.toLowerCase()] ?? heading, items: [] }
      release.groups.push(group)
      continue
    }

    if (line.startsWith("- ")) {
      const item = plainText(line.slice(2))
      if (!group) {
        group = { title: "", items: [] }
        release.groups.push(group)
      }
      group.items.push(item)
      continue
    }

    if (line && !line.startsWith("#") && !group) release.intro.push(plainText(line))
  }

  return releases.filter((entry) => entry.groups.some((item) => item.items.length > 0))
}

export function formatChangelogDate(date: string) {
  const [year, month, day] = date.split("-").map(Number)
  return new Intl.DateTimeFormat("pt-BR", { day: "numeric", month: "long", year: "numeric" }).format(new Date(year, month - 1, day))
}
